import {createAction, props} from '@ngrx/store';
import {RecordClassifica, Torneo} from '../../../../core/@types';
import {TorneiDetailFiltriState} from '../reducers/tornei-detail.reducer';
import {HttpErrorResponse} from '@angular/common/http';

export const initializeTorneo = createAction(
  '[Tornei][Detail] initialize torneo data'
);

export const LoadTorneoData = createAction(
  '[Tornei][Detail] Load torneo data',
  props<{ id: number }>()
);

export const LoadTorneoDataSuccess = createAction(
  '[Tornei][Detail] Load torneo data Success',
  props<{ torneo: Torneo }>()
);

export const LoadTorneoDataError = createAction(
  '[Tornei][Detail] Load torneo data Error',
  props<{ error: any }>()
);

export const LoadClassificaTorneoData = createAction(
  '[Tornei][Detail] Load classifica torneo data',
  props<{ id: number }>()
);

export const LoadClassificaTorneoDataSuccess = createAction(
  '[Tornei][Detail] Load classifica torneo data success',
  props<{ torneo: Torneo; classifica: RecordClassifica[] }>()
);

export const LoadClassificaTorneoDataError = createAction(
  '[Tornei][Detail] Load classifica torneo data error',
  props<{ error: any }>()
);

export const SetFilters = createAction(
  '[Tornei][Detail] Set Filters',
  props<{ filters: TorneiDetailFiltriState }>()
);

export const SaveTorneo = createAction(
  '[Tornei][Detail] save torneo',
  props<{ torneo: Torneo; mode: 'insert' | 'update' }>()
);

export const SaveTorneoSuccess = createAction(
  '[Tornei][Detail] save torneo Success',
  props<{ torneo: Torneo; mode: 'insert' | 'update'; classifica: RecordClassifica[] }>()
);

export const SaveTorneoError = createAction(
  '[Tornei][Detail] save torneo Error',
  props<{ error: HttpErrorResponse }>()
);

export const DeleteTorneo = createAction(
  '[Tornei][Detail] delete torneo',
  props<{ id: Number; }>()
);

export const DeleteTorneoSuccess = createAction(
  '[Tornei][Detail] delete torneo Success',
  props<{ id: Number }>()
);

export const DeleteTorneoError = createAction(
  '[Tornei][Detail] delete torneo Error',
  props<{ error: any }>()
);

export const LoadAnniTornei = createAction(
  '[Tornei][Detail] load anni tornei'
);

export const LoadAnniTorneiSuccess = createAction(
  '[Tornei][Detail] load anni tornei success',
  props<{ anniTornei: string[] }>()
);

export const AddImmagineTorneo = createAction(
  '[Tornei][Detail] add immagine torneo'
);

export const DeleteImmagineTorneo = createAction(
  '[Tornei][Detail] delete immagine torneo'
);

export const SendAllegato = createAction(
  '[Tornei][Detail] Send Allegato'
);

export const SendAllegatoSuccess = createAction(
  '[Tornei][Detail] Send Allegato Success',
  props<{ torneo: Torneo }>()
);

export const SendAllegatoError = createAction(
  '[Tornei][Detail] Send Allegato Error',
  props<{ errorMessage?: string }>()
);

export const DeleteAllegatoSuccess = createAction(
  '[Tornei][Detail] delete Allegato Success',
  props<{ torneo: Torneo }>()
);
